// @ts-nocheck
/* eslint-disable */
import { _ } from "~/i18n";
import Point from "./point";
import Line from "./line";
import { Scene, store } from "./globals";
import { watch, watchCoordinates } from "~/state/util";
import { Unsubscribe } from "redux";
import { icon, node } from "~/util/dom";

const EDGE_THRESHOLD = 10; // pocet [%] u kterych se presunuje popup zleva/zprava
const LINE_CURSOR_MAX_DISTANCE = 4; // [px] test u cary, jestlize je kurzor u takove vzdalenosti od ni

/**
 * Interakce - carkovana cara za kurzorem a popup pro vzdalenost.
 */
export default class InteractivePoint {
	_storeUnsubscribe: Unsubscribe;

	/**
	 * Konstruktor.
	 *
	 * @param  {DistanceMeter}   owner Instance rodice
	 */
	constructor(owner) {
		this._owner = owner;
		this._cb = null;
		this._visible = false;
		this._recoverState = false;
		this._sl = [];
		this._moveData = {
			point: null,
			line: null,
			endCoords: null
		};
		this._lastMouseMoveEvent = null;
		this._dom = {
			sceneCont: Scene.getContainer(),
			layoutContent: Mapy.getComponent("layout").getContent()
		};
		this._cachedLines = null;
		this._active = false;
		this._cancel = false;
		this._isMobile = Mapy.Util.isMobile();
		this._storeUnsubscribe = null;
		this._build();
	}

	/**
	 * Jde videt interakce?
	 *
	 * @return {Boolean}
	 */
	get visible() {
		return this._visible;
	}

	/**
	 * Je aktivni?
	 *
	 * @return {Boolean}
	 */
	get active() {
		return this._active;
	}

	/**
	 * Je povolena interakce?
	 *
	 * @return {Boolean}
	 */
	get enabled() {
		return (!this._cancel);
	}

	/**
	 * Ziskani popup.
	 *
	 * @return {Element}
	 */
	get popup() {
		return this._dom.distancePopup;
	}

	/**
	 * Callback funkce pri zmene viditelnosti.
	 *
	 * @param  {Function} cb Cb(state) ktery rika, jestli jsme se zobrazili/skryli tlacitko ukoncit mereni
	 */
	set cb(cb) {
		if (typeof cb === "function") {
			this._cb = cb;

			let visible = !this._dom.cancelBtn.classList.contains("hide");

			this._sendSignal(visible);
		}
	}

	/**
	 * Pripnuti popupu pro vzdalenost do DOMu.
	 */
	addPopup() {
		if (this._dom.distancePopup) return;

		this._dom.distancePopup = node("div", { className: "distance-popup", textContent: ""});
		Scene.getContainer().appendChild(this._dom.distancePopup);
	}

	/**
	 * Nastav popup vzdalenost a souradnice.
	 * Reaguje na okraje mapy.
	 *
	 * @param {Number} distance Vzdalenost
	 * @param {Number} x Souradnice X
	 * @param {Number} y Souradnice Y
	 */
	setPopup(distance, x, y) {
		if (!this._dom.distancePopup) return;

		let sizeX = Scene.getSize().x;
		let edge = sizeX * (EDGE_THRESHOLD / 100);

		this._dom.distancePopup.textContent = distance ? Mapy.Util.formatDistancemeterDistance(distance).string : "";
		this._dom.distancePopup.style.left = x + "px";
		this._dom.distancePopup.style.top = y + "px";

		let distClsOper = "";

		if (x < edge) {
			distClsOper = "remove";
		}
		else if (x >= edge && x <= sizeX - edge) {
			distClsOper = x <= sizeX / 2 ? "add" : "remove";
		}
		else {
			distClsOper = "add";
		}

		this._dom.distancePopup.classList[distClsOper]("translate-x");
	}

	/**
	 * Odstraneni popu.
	 */
	removePopup() {
		if (this._dom.distancePopup) {
			this._dom.distancePopup.remove();
			this._dom.distancePopup = null;
		}
	}

	/**
	 * Zapnuti interakce, pri zadanem e vytvori taky popup a caru.
	 *
	 * @param  {Event} [e] Mouse event
	 */
	show(e) {
		let endCoords = this._getEndCoords();

		if (!endCoords || !this._active) return;

		// vytvoreni
		if (!this._moveData.point) {
			this._moveData.endCoords = endCoords;

			this._moveData.point = new Point(this._owner.layers.points, Scene);
			this._moveData.line = new Line(this._owner.layers.lines, Scene);

			this.addPopup();
			this._dom.cancelBtn.classList.remove("hide");
			this._sendSignal(true);
		}

		// nastaveni
		if (e) {
			let coords = Scene.coordsFromEvent(e);

			// bod
			if (!this._moveData.point.marker) {
				this._moveData.point.create(false, coords, { pointerEvents: "none" });
				this._moveData.point.setNoEvents(true);
			}
			else {
				this._moveData.point.coords = coords;
			}

			// cara
			let points = Line.calculateLinePoints(this._moveData.endCoords, coords);

			if (!this._moveData.line.geom) {
				this._moveData.line.create(points, { pointerEvents: "none" });
				this._moveData.line.setStyleDash();
			}
			else {
				this._moveData.line.coords = points;
			}

			let distance = this._moveData.endCoords.distance(coords);

			if (distance >= 1) {
				this.setPopup(distance, e.clientX, e.clientY);
			}
		}

		this._visible = true;
		this._cancel = false;
	}

	/**
	 * Skryti interakce - pri plnem se skryje take tlacitko a zakaze se interakce pro mousemove.
	 *
	 * @param  {Number} [full] Plne skryti
	 */
	hide(full) {
		if (this._moveData.point) {
			this._moveData.point.destroy();
			this._moveData.point = null;
		}

		if (this._moveData.line) {
			this._moveData.line.destroy();
			this._moveData.line = null;
		}

		this._moveData.endCoords = null;
		this.removePopup();
		this._visible = false;

		if (full) {
			this._cancel = true;
			this._dom.cancelBtn.classList.add("hide");
			this._sendSignal(false);
		}
	}

	/**
	 * Vycisteni kese - pri kazde aktualizace je potreba prepocitat cary.
	 */
	cleanCache() {
		// potreba znovu naplnit pole
		this._cachedLines = null;
		this._moveData.endCoords = this._getEndCoords();

		if (!this._moveData.endCoords) {
			this.hide();
		}
	}

	/**
	 * Aktivace - bind udalosti.
	 */
	activate() {
		if (this._active || Mapy.Util.isMobile()) return;

		// TODO: tohle se taky musi casem zrusit, ale to az cely nastroj bude pracovat nad SMap instanci a ne nad Scene
		this._sl.push(Scene.addListener("map-pan", e => {
			this._setRecover();
		}));
		const wt = watch(store.getState, "map", watchCoordinates);

		this._storeUnsubscribe = store.subscribe(wt((newMap, oldMap) => {
			if (newMap.animating) {
				this._setRecover();
			} else {
				this._cachedLines = null;

				this._recover();
			}
		}));

		if (!this._isMobile) {
			this._dom.sceneCont.addEventListener("pointermove", this);
			this._dom.layoutContent.addEventListener("pointerenter", this);
			document.addEventListener("keydown", this);
		}

		this._dom.sceneCont.appendChild(this._dom.cancelBtn);
		this._active = true;
	}

	/**
	 * Aktivace - bind udalosti.
	 */
	deactivate() {
		if (!this._active) return;

		Scene.removeListeners(this._sl);
		this._storeUnsubscribe?.();
		this._storeUnsubscribe = null;

		if (!this._isMobile) {
			this._dom.sceneCont.removeEventListener("pointermove", this);
			this._dom.layoutContent.removeEventListener("pointerenter", this);
			document.removeEventListener("keydown", this);
		}

		this.hide(true);

		this._dom.cancelBtn.remove();
		this._active = false;
	}

	handleEvent(e) {
		switch (e.type) {
			case "keydown":
				let keyCode = e.which || e.keyCode;

				if (keyCode == 27) {
					// vypnuti pres ESC
					this.hide(true);
				}
				break;

			case "click":
				// stisk tlacitka pro ukonceni mereni
				if (this._dom.cancelBtn.contains(e.target)) {
					this.hide(true);
				}
				break;

			case "pointerenter":
				// odjeti mimo mapu
				this.hide();
				break;

			case "pointermove":
				// pohyb po mape
				e.preventDefault();
				this._lastMouseMoveEvent = e;

				if (this._cancel) return;

				let coords = Scene.coordsFromEvent(e);

				// plati ze na pozici kurzoru je geometrie cary? skryje interakci, jinak zobrazime
				if (this._geometryOnCursor(coords) || (Scene.isWasmActive() && e.target.nodeName.toLowerCase() !== "canvas")) {
					this.hide();
				}
				else {
					this.show(e);
				}
				break;
		}
	}

	/**
	 * Vytvoreni tlacitka pro zruseni interakce.
	 */
	_build() {
		let cancelBtn = node("button", { className: "cancel-btn" });
		cancelBtn.appendChild(icon("close"));
		cancelBtn.appendChild(node("span", { className: "txt", textContent: _("distanceMeter.cancel") }));
		cancelBtn.addEventListener("click", this);
		cancelBtn.classList.add("hide");

		this._sendSignal(false);
		this._dom.cancelBtn = cancelBtn;
	}

	/**
	 * Nachazi se geometrie cary na pozici souradnic?
	 * Kdyz nename data, tak si je vytvorime a nakesujeme, u dlouhych car musime pridat vsechny useky,
	 * proto je tam forEach + for.
	 *
	 * @param  {SceneCoords} coords Souradnic
	 * @return {Boolean}
	 */
	_geometryOnCursor(coords) {
		let lines = [];

		if (this._cachedLines) {
			lines = this._cachedLines;
		}
		else {
			let items = this._owner.getItems();

			if (items.length <= 1) return false;

			items.forEach((i, ind) => {
				let lp = i.getLinePoints().map(i => Scene.coordsToPixel(i));

				if (lp.length) {
					for (let j = 0, max = lp.length; j < max; j++) {
						if (j > 0) {
							lines.push({
								start: lp[j - 1],
								end: lp[j],
								ind
							});
						}
					}
				}
			});

			this._cachedLines = lines;
		}

		return Mapy.Util.linesPointIntersection(Scene.coordsToPixel(coords), lines, LINE_CURSOR_MAX_DISTANCE);
	}

	/**
	 * Ziskani souradnic u posledniho itemu.
	 *
	 * @return {SceneCoords}
	 */
	_getEndCoords() {
		let items = this._owner.getItems();

		return (items.length ? items[items.length - 1].getCoords() : null);
	}

	/**
	 * Znovu zobrazeni interakce, ktera byla predtim skryta.
	 */
	_recover() {
		if (this._recoverState && this._lastMouseMoveEvent) {
			this._recoverState = false;

			this.show(this._lastMouseMoveEvent);
		}
	}

	/**
	 * Ulozeni interakce pro jeji pozdejsi zobrazeni - napr. pri pohybu mapu, zoom start...
	 */
	_setRecover() {
		if (this._visible) {
			this._recoverState = true;
			this._cancel = true;
			this.hide();
		}
	}

	/**
	 * Poslani signalu o zmene viditelnosti.
	 *
	 * @param  {Boolean} state
	 */
	_sendSignal(state) {
		if (this._cb) {
			this._cb(state);
		}
	}
}
